import NotificationsReducer from './NotificationsReducer';

export default from './NotificationsContainer';
export { addNotification } from './NotificationsActions';

export const NotificationsReducers = {
  NotificationsReducer,
};
